import { Link } from 'gatsby';
import React, { useContext } from 'react';
import { AppContext, App } from './app';
import { navigate } from 'gatsby';

const Menu = ({ location }) => {
    const context = useContext(AppContext);
    const { state, dispatch } = context;

    const logout = e => {
        e.preventDefault();
        dispatch({ type: 'logout' });
        navigate('/');
    };

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                <symbol id="bc4u" viewBox="0 0 960 187">
                    <path
                        d="M0 0h960v187H0V0zm48.669 142.832h57.757c19.4 0 29.027-12.419 29.027-26.76 0-12.419-8.293-22.472-18.808-24.1 9.33-2.07 16.883-10.349 16.883-22.62 0-12.419-9.33-25.133-28.879-25.133h-55.98v98.612zm25.473-60.469v-17h24.732c5.183 0 8.737 3.548 8.737 8.427a8.356 8.356 0 0 1-8.737 8.575H74.142zm0 39.327v-18.333h25.62c6.22 0 9.774 4.288 9.774 9.315 0 5.322-3.7 9.018-9.774 9.018h-25.62zm119.364 22.916c24.584 0 37.468-13.75 43.836-26.464l-21.918-10.349a23.966 23.966 0 0 1-21.918 14.341c-15.4 0-26.805-12.419-26.805-28.534s11.4-28.534 26.805-28.534a23.965 23.965 0 0 1 21.918 14.341l21.918-10.349c-6.516-13.01-19.252-26.464-43.836-26.464-29.619 0-52.721 20.55-52.721 51.006 0 30.308 23.102 51.006 52.721 51.006zm118.181-1.774h27.694l-37.32-98.612h-31.989L232.9 142.832h27.693l5.037-14.932h41.022zM286.067 66.4l13.921 40.066h-27.694zm49.316 62.538c9.922 9.462 23.843 15.672 43.836 15.672 26.509 0 41.17-13.158 41.17-32.969 0-22.325-22.51-27.056-38.8-30.456-10.959-2.07-17.031-3.844-17.031-9.019 0-4.287 3.258-7.688 11.7-7.688a45.952 45.952 0 0 1 27.842 10.2l13.92-18.187c-10.515-9.018-24.288-13.749-40.134-13.749-25.324 0-39.393 14.341-39.393 30.9 0 23.359 22.806 27.5 39.1 30.751 10.514 2.218 16.882 4.436 16.882 10.054 0 4.731-5.331 8.427-14.069 8.427a44.668 44.668 0 0 1-31.544-13.011zm159.793 13.9h25.473V44.22h-25.473v36.813h-41.022V44.22h-25.472v98.612h25.472v-39.623h41.022v39.623zm81.305 0H602.1V124.8h12v-22.33h-12V44.22h-35.393l-37.468 60.764V124.8h47.242v18.037zm0-76.436v36.068h-22.51zm73.012 76.436h25.472v-39.77l37.32-58.842h-28.878l-21.178 36.37-21.474-36.376h-28.73l37.468 58.842v39.77zM705.03 93.6c0 30.012 22.659 51.006 52.87 51.006s52.722-20.994 52.722-51.006-22.511-51.007-52.722-51.007-52.87 20.994-52.87 51.007zm79.675 0c0 15.967-10.514 28.534-26.805 28.534-16.438 0-26.953-12.567-26.953-28.534 0-16.115 10.515-28.534 26.953-28.534 16.291 0 26.805 12.419 26.805 28.534zm35.247 9.314c0 24.246 14.217 41.692 45.909 41.692s45.762-17.3 45.762-41.84V44.22h-25.917v57.807c0 11.679-6.22 20.107-19.845 20.107-13.772 0-19.992-8.428-19.992-20.107V44.22h-25.917v58.694z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="old-version" viewBox="0 0 178 40">
                    <rect
                        width="178"
                        height="40"
                        rx="2"
                        ry="2"
                        fill="#e31927"
                    />
                    <path
                        d="M11.484 20.045a8.048 8.048 0 0 0 8.375 8.279 8.055 8.055 0 0 0 8.4-8.279 8.054 8.054 0 0 0-8.4-8.279 8.048 8.048 0 0 0-8.375 8.279zm13.261 0c0 2.976-1.925 5.256-4.885 5.256S15 23.021 15 20.045c0-3 1.9-5.256 4.861-5.256s4.884 2.257 4.884 5.256zm5.922 7.991h10.2v-3h-6.783V12.03h-3.417v16.007zm12.588 0h6.329c5.03 0 8.52-3.168 8.52-7.991s-3.49-8.015-8.52-8.015h-6.33v16.007zm3.417-3V15.03h2.912a4.691 4.691 0 0 1 5.03 5.016 4.8 4.8 0 0 1-5.03 4.992h-2.912zm24.525 3h4.284l6.185-16.006h-3.9l-4.427 12.311-4.453-12.311h-3.9zm11.962 0h11.359v-2.951h-7.942v-3.72h7.774v-2.928h-7.774v-3.48h7.942V12.03H83.159v16.007zm23.105 0h3.923l-3.61-6.1a4.6 4.6 0 0 0 3.513-4.752c0-2.976-2.045-5.16-5.391-5.16h-7.508v16.013h3.418V22.3h2.5zm.336-10.87a2.213 2.213 0 0 1-2.407 2.208h-3.586v-4.416h3.586a2.213 2.213 0 0 1 2.407 2.208zm4.958 8.615a9.265 9.265 0 0 0 6.811 2.544c4.332 0 6.426-2.208 6.426-5.136 0-3.552-3.369-4.344-6.017-4.944-1.853-.432-3.2-.768-3.2-1.848 0-.96.819-1.632 2.359-1.632a6.861 6.861 0 0 1 4.6 1.752l1.9-2.5a8.945 8.945 0 0 0-6.257-2.232c-3.779 0-6.089 2.16-6.089 4.824 0 3.576 3.369 4.3 5.992 4.9 1.853.432 3.249.84 3.249 2.04 0 .912-.914 1.8-2.791 1.8a7.05 7.05 0 0 1-5.1-2.16zm15.548 2.256h3.418V12.03h-3.418v16.007zm5.824-7.991a8.388 8.388 0 0 0 16.775 0 8.388 8.388 0 0 0-16.774-.001zm13.261 0c0 2.976-1.925 5.256-4.885 5.256s-4.862-2.28-4.862-5.256c0-3 1.9-5.256 4.862-5.256s4.886 2.256 4.886 5.255zm16.992 7.991h3.3V12.03h-3.418V22.4l-7.437-10.37h-3.514v16.007h3.417V17.286z"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                </symbol>

                <symbol id="m-home" viewBox="0 0 54 48">
                    <path
                        d="M30 42v-9h-6v9H12V18L27 8l15 10v24H30zm18-28V0h-6v10L27 0 0 18l4 6 2-1v25h42V23l2 1 4-6z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-join" viewBox="0 0 50 48">
                    <path
                        d="M39 0h-2c-6.214 0-11 5.787-11 12v6H0v30h38V18h-6v-6c0-2.914 2.108-6 5-6h2c2.892 0 5 3.087 5 6v12h6V12c0-6.213-4.807-12-11-12zm-7 42H6V24h26v18z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-loginstart" viewBox="0 0 48 48">
                    <path
                        d="M6 0v6h36v36H6v6h42V0H6zm13 14l7 7H0v6h26l-7 7 4 4 13-14-13-14zM6 6h6v3H6V6zm0 33h6v3H6v-3z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-stats" viewBox="0 0 48 48">
                    <path
                        d="M36 18v-6H12v6h24zm6-12v36H6V6h36zm6-6H0v48h48V0zM36 27v-6H12v6h24zm0 9v-6H12v6h24z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-tools" viewBox="0 0 48 48">
                    <path
                        d="M0 0v48h48V0H0zm6 6zm15 36H6V6h15v36zm21 0H27V27h15v15zM27 21V6h15v15H27z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-feedback" viewBox="0 0 48 48">
                    <path
                        d="M42 6v27H24l-9 9v-9H6V6h36zm6-6H0v39h9v9h8l9-9h22V0zM11 12h26v6H11v-6zm0 9h26v6H11v-6z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol id="m-logout" viewBox="0 0 48 48">
                    <path
                        d="M48 0v6H6v36h42v6H0V0h48zm-6 6h6v33h-6V6zm0 33h6v3h-6v-3zM28 24l8 8-5 4-7-7.826L17 36l-5-4 8-8-8-8 5-4 7 7.826L31 12l5 4-8 8z"
                        fillRule="evenodd"
                    />
                </symbol>

                <symbol id="link-next" viewBox="0 0 14 24">
                    <path
                        d="M3.95.009L.015 3.443l7 8.566-7 8.566 3.935 3.434 10.058-12z"
                        fillRule="evenodd"
                    />
                </symbol>
            </svg>
            <div>
                <div className="menu show-for-tablet">
                    <Link to="/" title="Home">
                        <div className="menu-item">
                            <svg style={{ width: 27, height: 24 }}>
                                <use
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    xlinkHref="#m-home"
                                ></use>
                            </svg>
                            <span>Home</span>
                        </div>
                    </Link>
                    <a href="https://admin.ccbill.com/" title="Statistics">
                        <div className="menu-item">
                            <svg style={{ width: 24, height: 24 }}>
                                <use
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    xlinkHref="#m-stats"
                                ></use>
                            </svg>
                            <span>Stats</span>
                        </div>
                    </a>
                    <Link to="/tools-fhg" title="Promo tools">
                        <div className="menu-item">
                            <svg style={{ width: 24, height: 24 }}>
                                <use
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    xlinkHref="#m-tools"
                                ></use>
                            </svg>
                            <span>Tools</span>
                        </div>
                    </Link>
                    {state && state.affiliateId ? (
                        <>
                            <Link to="/contact" title="Contact">
                                <div className="menu-item">
                                    <svg style={{ width: 25, height: 24 }}>
                                        <use
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            xlinkHref="#m-feedback"
                                        ></use>
                                    </svg>
                                    <span>Contact</span>
                                </div>
                            </Link>
                            <a href="#" onClick={logout} title="Logout">
                                <div className="menu-item">
                                    <svg style={{ width: 25, height: 24 }}>
                                        <use
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            xlinkHref="#m-logout"
                                        ></use>
                                    </svg>
                                    <span>Logout</span>
                                </div>
                            </a>
                        </>
                    ) : (
                        <>
                            <a
                                href="https://nats.bcash4you.com/external.php?page=signup"
                                title="Signup"
                            >
                                <div className="menu-item">
                                    <svg style={{ width: 25, height: 24 }}>
                                        <use
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            xlinkHref="#m-join"
                                        ></use>
                                    </svg>
                                    <span>Signup</span>
                                </div>
                            </a>
                            <Link to="/login" title="Login">
                                <div className="menu-item">
                                    <svg style={{ width: 24, height: 24 }}>
                                        <use
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            xlinkHref="#m-loginstart"
                                        ></use>
                                    </svg>
                                    <span>Login</span>
                                </div>
                            </Link>
                        </>
                    )}
                </div>
            </div>

            <div className="top-menu">
                <div className="top-menu-block first">
                    <div className="top-menu-centered">
                        <div className="top-menu-item hide-for-tablet">
                            {state && state.affiliateId ? (
                                <span>
                                    Your affiliate ID: {state.affiliateId}
                                </span>
                            ) : (
                                <span>Watch4beauty affiliate program</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="top-menu-block second">
                    <div className="top-menu-centered">
                        <div className="top-menu-item">
                            <Link to="/" title="Home">
                                <svg className="bcash4you">
                                    <use
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        xlinkHref="#bc4u"
                                    ></use>
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="top-menu-block third hide-for-tablet">
                    <div className="top-menu-centered">
                        <div className="top-menu-item">
                            <a
                                href="https://admin.ccbill.com/"
                                title="Statistics"
                            >
                                Statistics
                            </a>
                        </div>
                        <div className="top-menu-item">
                            <Link to="/tools-fhg" title="Promo tools">
                                Promo tools
                            </Link>
                        </div>
                        {state && state.affiliateId ? (
                            <>
                                <div className="top-menu-item">
                                    <Link to="/contact" title="Contact">
                                        Contact
                                    </Link>
                                </div>
                                <div className="top-menu-item">
                                    <a href="#" onClick={logout} title="Logout">
                                        <svg>
                                            <use
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                xlinkHref="#m-logout"
                                            ></use>
                                        </svg>
                                    </a>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="top-menu-item">
                                    <a
                                        href="https://nats.bcash4you.com/external.php?page=signup"
                                        title="Signup"
                                    >
                                        Signup
                                    </a>
                                </div>
                                <div className="top-menu-item">
                                    <Link to="/login" title="Login">
                                        <svg>
                                            <use
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                xlinkHref="#m-loginstart"
                                            ></use>
                                        </svg>
                                    </Link>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {state &&
            state.affiliateId &&
            location.pathname.indexOf('tools-') !== -1 ? (
                <>
                    <div className="spacer spacer-48">&nbsp;</div>
                    <div className="spacer spacer-24">&nbsp;</div>
                    <p className="link">
                        {location.pathname === '/tools-fhg' ? (
                            <span className="redtext">FHG</span>
                        ) : (
                            <Link to="/tools-fhg" title="FHG">
                                FHG
                            </Link>
                        )}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {location.pathname === '/tools-banners' ? (
                            <span className="redtext">Banners</span>
                        ) : (
                            <Link to="/tools-banners" title="Banners">
                                Banners
                            </Link>
                        )}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {location.pathname === '/tools-potd' ? (
                            <span className="redtext">POTD</span>
                        ) : (
                            <Link to="/tools-potd" title="POTD">
                                POTD
                            </Link>
                        )}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {location.pathname === '/tools-links' ? (
                            <span className="redtext">Links</span>
                        ) : (
                            <Link to="/tools-links" title="Links">
                                Links
                            </Link>
                        )}
                    </p>
                    <div className="spacer line spacer-24">&nbsp;</div>
                    <div className="spacer spacer-80">&nbsp;</div>
                </>
            ) : (
                <>
                    <div className="spacer spacer-104">&nbsp;</div>
                </>
            )}
        </>
    );
};

export default Menu;
